import React from "react";
import usePagination from "../../../hooks/usePagination.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
const PaginationLoader = () => {
  const { ref, hasMoreToFetch } = usePagination();

  return (
    <div>
      <div ref={ref} className="fetching-trigger-element" />
      {hasMoreToFetch ? (
        <div className="pagination-loader">
          <LoadingImageElement />
        </div>
      ) : null}
    </div>
  );
};

export default PaginationLoader;
